<template>
<div id="choose">
  <div class="sectionIntro">
    <div class="sectionBack">
    </div>
    <div class="introCover">
      <img src="@/../static/image/content/chooseCategoryIntro.png" />
    </div>
    <div class="introContent">

      <div class="versionContent">
        <h2 class="pageTitle">{{$t('avatamsaka.category.title')}}</h2>
        <div class="sectionVersion">
          <div class="versionGroup">
            <div class="version" @click="getVersionPath(4)">

              <div class="imgContent">
            <img src="@/../static/image/content/indexVersion04.jpg" />
          </div>
            <div class="content">
              <h2>
                {{$t('avatamsaka.sutras.sutra', {
                  'noticeType': $t(`avatamsaka.sutras.sutra01books[3].text`)
                })}}
              </h2>
              <p>
                {{$t('avatamsaka.category.verIntro', {
                  'noticeType': $t(`avatamsaka.category.introType[3].text`)
                })}}
              </p>
            </div>
          </div>
          <div class="version" @click="getVersionPath(5)">

              <div class="imgContent">
            <img src="@/../static/image/content/indexVersion05.jpg" />
          </div>
            <div class="content">
              <h2>
                {{$t('avatamsaka.sutras.sutra', {
                  'noticeType': $t(`avatamsaka.sutras.sutra01books[4].text`)
                })}}
              </h2>
              <p>
                {{$t('avatamsaka.category.verIntro', {
                  'noticeType': $t(`avatamsaka.category.introType[4].text`)
                })}}
              </p>
            </div>
          </div>
            <div class="version" @click="getVersionPath(3)">

              <div class="imgContent">
            <img src="@/../static/image/content/indexVersion03.jpg" />
          </div>
            <div class="content">
              <h2>
                {{$t('avatamsaka.sutras.sutra', {
                  'noticeType': $t(`avatamsaka.sutras.sutra01books[2].text`)
                })}}
              </h2>
              <p>
                {{$t('avatamsaka.category.verIntro', {
                  'noticeType': $t(`avatamsaka.category.introType[2].text`)
                })}}
              </p>
            </div>
          </div>
          <div class="version" @click="getVersionPath(2)">

          <div class="imgContent">
            <img src="@/../static/image/content/indexVersion02.jpg" />
          </div>
            <div class="content">
              <h2>
                {{$t('avatamsaka.sutras.sutra', {
                  'noticeType': $t(`avatamsaka.sutras.sutra01books[1].text`)
                })}}
              </h2>
              <p>
                {{$t('avatamsaka.category.verIntro', {
                  'noticeType': $t(`avatamsaka.category.introType[1].text`)
                })}}
              </p>
            </div>
          </div>
          <div class="version" @click="getVersionPath(1)">

            <div class="imgContent">
              <img src="@/../static/image/content/indexVersion01.jpg" />
            </div>
            <div class="content">
              <h2>
                {{$t('avatamsaka.sutras.sutra', {
                  'noticeType': $t(`avatamsaka.sutras.sutra01books[0].text`)
                })}}
              </h2>
              <p>
                {{$t('avatamsaka.category.verIntro', {
                  'noticeType': $t(`avatamsaka.category.introType[0].text`)
                })}}
              </p>
            </div>
          </div>
        </div>
        <div class="postscript">
          {{$t('avatamsaka.category.postscript')}}
        </div>
        <div class="postscriptMobile">
          {{$t('avatamsaka.category.postscriptMobile')}}
        </div>
      </div>

      </div>

    </div>

  </div>

</div>
</template>

<script>

export default {
  name: 'choose',
  data() {
    return {
    };
  },
  methods: {
    getVersionPath(versionId) {
      this.$router.push({
        name: 'category',
        params: {
          vid: versionId,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>

#choose {
  .sectionIntro {
      // display: flex;
      padding-bottom: 50px;
      position: relative;

    .sectionBack {
      margin-bottom: 40px;
      width: 100%;
      height: 60%;
      top: 0;
      background: #d9e2c4;
      position: absolute;
    }

    .sectionBack::after {

        border-top: 20vh solid #d9e2c4;
        border-right: 50vw solid transparent;
        border-left: 50vw solid transparent;
        content: "";
        top: 100%;
        left: 0;
        position: absolute;

    }

    .introCover {
      position: absolute;
      top: 0;
      right: 0;
      padding: 0px;
      margin: 0px;
      img {
        max-width: 500px;
        width: 100%;
        float: right;
      }
    }
    .introContent {


      > h2 {
        padding-top: 2em;
        margin-left: 20px;
      }

      p {
        padding: 20px;
        padding-left: 0px;
      }
      position: sticky;
      text-align: left;
      align-self: center;
    }

    .versionContent {
      .pageTitle {
        padding: 20px;
        padding-top: 2em;
        padding-bottom: 0px;
      }
    }


  }

  .sectionVersion {

    flex-direction: row;
    margin-top: 2em;

    .versionGroup {
      display: flex;

      >.version:hover {
        box-shadow: 0px 0px 10px #fff, 0px 0px 10px #fff,
          0px 0px 10px #fff, 0px 0px 10px #fff, 0px 0px 10px #fff,
          0px 0px 10px #fff, 0px 0px 10px #fff
          , 0px 0px 10px rgb(55, 73, 57), 0px 0px 10px rgb(23, 78, 64);
        cursor: pointer;
      }

    .version {
      color: #ffffff;
      background: rgba(29, 52, 31, 0.6);
      margin: 30px;
      padding: 20px;
      height: auto;
      flex: 1;
      position: relative;

      .content {

        text-align: left;
        padding-top: 15px;
        padding-bottom: 15px;
        font-size: 1.1em;
        font-weight: 400;
        float: left;
        h2{
          padding: 0;
          font-weight: bold;
          margin-bottom: 0px;
        }
        h2:hover {
          cursor: pointer;
        }
        p{
          padding: 0px;
          margin: 0px;
        }
      }
      .imgContent {
        display: block;
        width: 100%;
        img {
          width: 100%;
        }
        float: left;
      }
    }
}

  }
  @media (min-width: 1025px) {
    .postscript {
    padding: 20px;
    display: block;
  }
  .postscriptMobile {
    display: none;
  }
  }
  @media (max-width: 1024px) {
      .postscriptMobile {
        display: block;
      }
      .postscript {
        display: none;
      }
      .versionContent {
        .pageTitle {
          text-shadow: 1px 1px 10px #ffffff, 1px 1px 10px #ffffff
            , 1px 1px 10px #ffffff, 1px 1px 10px #ffffff;
          font-weight: 500;
          // background: #ffffff60;
          margin-top: 0px;
          background: rgba(255, 255, 255, 0.4);
          background-clip: padding-box;
          border-top: 1.7em solid transparent;
          margin-bottom: 0px;
        }
      }

      h2 {
        text-align: center;
      }

      button {
        display: block;
        margin: 20px auto;
      }

      .sectionIntro {

        .introCover {
          position: absolute;
          right: 0;
          padding: 0px;
          margin: 0px;
          img {
            max-width: 500px;
            width: 100%;
            float: right;
          }
        }
        .introContent {

          > h2 {
            margin-left: 0px;
            color: red;
            display: none;
          }

          p {
            font-size: 0.8em;
            margin: 0px;
            padding: 0px 20px;
            overflow: scroll;
            position: relative;
            line-height: 1.2em;
            max-height: 15.6em;
            margin-right: -0.9em;
            padding-right: 0.9em;
          }

          position: sticky;
          flex: 2;
          padding: 0px;
          z-index: 1;
          margin: 20px;
          margin-top: 0px;
          text-align: left;
          align-self: center;

          .versionGroup {
            background: rgba(255, 255, 255, 0.4);
          }
        }
      }


      .sectionVersion {

        margin-top: 0px;

        .versionGroup {
          height: 100%;
          width: 100%;

          display: grid;
          width: 100%;
        .version {
          margin: 30px;
          margin-top: 0px;
          padding: 20px;
          height: auto;
          position: relative;

          .content {

            padding: 0px;
            width: calc(100% - 128px);
            overflow: hidden;
            float: left;
            h2{
              padding-bottom: 0px;
              font-weight: bold;
              font-size: 0.9em;
              margin-bottom: 0px;
            }
            h2:hover {
              cursor: pointer;
            }
            p {

              font-size: 0.8em;
              margin: 0px;
              padding: 0px;

              overflow: hidden;
              position: relative;
              line-height: 1.2em;
              max-height: 12em;
              margin-right: -0.9em;
              padding-right: 0.9em;
            }
            p:before {

              content: '...';

              position: absolute;
              right: 0;
              bottom: 0;
            }
          }
          .imgContent {
            padding-right: 0px;
            width: 128px;
            height: 200px;
            float: left;
            img {
              width: auto;
              height: calc(100% - 20px);
            }
          }
        }
    }

    :first-child {
      .version:first-child {
        margin-top: 30px;
      }
    }

      }


  }

}
</style>



// WEBPACK FOOTER //
// src/components/ChooseCategory.vue